import React, { Component } from 'react'

 class Calculator extends Component {
     constructor(props){
         super(props)
         
         this.state = {
             crypt1:'0',
             qty:0,
             cost: 0,
             loading:true,
            Data:null
         }
         this.pollData = this.pollData.bind(this)
     }
     componentDidMount(){
        this.pollData()
        setInterval(this.pollData, 10000)
        
    }
    pollData(){
        fetch("https://api.binance.com/api/v1/ticker/24hr#")
        .then(resp => resp.json())
        .then( data =>
        this.setState((prevState)  => ({
            Data: data, 
            loading: false,
        })))
    }
     handleCrypt1Change = event =>{
         this.setState({
             crypt1: event.target.value
         })
     }

    handleQtyChange = event =>{
        this.setState({
            qty: event.target.value,
        })
    }
    

    render() {
        let price= this.state.loading || !this.state.Data ? 0.0 : this.state.qty*this.state.Data[Number(this.state.crypt1)].lastPrice;
        return (
            <div>{this.state.loading || !this.state.Data ? (<div className="loader"><p>Loading...</p></div>):(
                <div><div className="loaded">
            <form >
                <h3>Crypto Calculator</h3>
                <hr className="convertorline"></hr>
                <br></br>
                <label>Convert  </label>
                <select value={this.state.crypt1} onChange={this.handleCrypt1Change} >
                    <option value="0">ETH to BTC</option>
                    <option value="1">LTC to BTC</option>
                    <option value="90">XRP to BTC</option>
                    <option value="59">ETC to BTC</option>
                    <option value="65">ZEC to BTC</option>
                    <option value="178">XLM to BTC</option>
                    <option value="312">REP to BTC</option>
                    <option value="127">BAT to BTC</option>
                    <option value="70">DASH to BTC</option>
                    <option value="194">WAVES to BTC</option>
                    <option value="422">BTC to USDC</option>
                    <option value="423">ETH to USDC</option>
                    <option value="452">LTC to USDC</option>
                    <option value="424">XRP to USDC</option>
                    <option value="512">ETC to USDC</option>
                    <option value="485">ZEC to USDC</option>
                    <option value="426">XLM to USDC</option>
                    <option value="443">WAVES to USDC</option>
                </select>
                <br></br>
                <div className="inputbox">
                <input type="number" value={this.state.qty} onChange={this.handleQtyChange}></input>
                {this.state.crypt1 && 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===6)? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,3)) : 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===7) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,7))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,4)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,3))) :
                 (
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===8) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,8))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,5)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,4))) :
                 (((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,5)))))))}    
                <p>Quantity</p>
                </div>
                <div className="inputbox">
                x <input type="number" value={this.state.Data[Number(this.state.crypt1)].lastPrice}></input>
                <p>Unit Price of             {this.state.crypt1 && 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===6)? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,3)) : 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===7) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,7))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,4)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,3))) :
                 (
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===8) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,8))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,5)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,4))) :
                 (((this.state.Data[Number(this.state.crypt1)].symbol).substring(0,5)))))))}    in  {this.state.crypt1 && 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===6)? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(3,6)) : 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===7) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,7))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,7)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(3,7))) :
                 (
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===8) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,8))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,8)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,8))) :
                 (((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,9)))))))}
                 </p>

                </div>
                <div className="inputbox">= <input type="number" value={!this.state.qty ?  0.0 : price}></input>
                {this.state.crypt1 && 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===6)? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(3,6)) : 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===7) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,7))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,7)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(3,7))) :
                 (
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).length)===8) ? 
                 ((((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,8))==="BTC")? 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,8)) : 
                 ((this.state.Data[Number(this.state.crypt1)].symbol).substring(4,8))) :
                 (((this.state.Data[Number(this.state.crypt1)].symbol).substring(5,9)))))))}
                <p>Total Price</p>
                </div>
                </form>
            </div>
            
            </div>)}</div>
        )
        
    }
    
}

export default Calculator



// WEBPACK FOOTER //
// ./src/calculator.js